import React, { memo } from 'react'
import { Modal } from 'antd'
import DefaultLayout from '../default'
import SelectForm from '../SelectForms'
import SelectFromGlobal from '../SelectForms/selectFromGlobal'
import MutationButton from '../SelectForms/mutationButton'
import SaveButton from '../../../components/SaveButton'

const ChildModal = ({
                      id,
                      name,
                      title,
                      isShow,
                      index,
                      link,
                      selFrom,
                      context,
                      topRecordId,
                      inLinkedObj,
                      change,
                      handleClose,
                    }) => {
  const inList = (typeof index === 'number')
  const indexStr = inList ? ' (' + (index + 1) + ')' : ''
  const roStr = context.mutable ? '' : '[viewing] '
  // strip index out of id, since it's not necessary (only one modal displayed at a time)
  // and then the auto-relevance can leverage the non-indexed id
  // let nid = inList ? id.slice(0, id.lastIndexOf('.')) + '[]' : id
  const handleSave = async () => {
    await context.saveDeferredMutations()
    handleClose()
  }
  const handleCancelSave = async () => {
    await context.cancelDeferredMutations()
    handleClose()
  }
  const buttons = []
  if (context.hasDeferredMutations()) {
    buttons.push(
      <button key="CancelSel"
              className={'btn btn-outline-secondary dart-btn-outline ml-3'}
              onClick={handleCancelSave}>CANCEL</button>,
      <SaveButton label={'SAVE'} saveHandler={handleSave}/>,
    )
  } else {
    buttons.push(
      <button key="OK" className={'btn btn-secondary dart-btn ml-3'} onClick={handleClose}>OK</button>,
    )
  }

  if (link) { // name or expr of query supplying object instances, to which this object can optionally be linked
    const queryStatus = context.getQueryStatus(link)
    if (queryStatus) {
      const {
        queryDef,
        canModify,
        hasLink,
      } = queryStatus
      if (queryDef && canModify && hasLink) {
        buttons.unshift(<MutationButton def={queryDef} queryStatus={queryStatus} context={context} spaceLeft={true}/>)
      }
      buttons.unshift(<SelectForm def={queryDef} queryStatus={queryStatus} context={context} spaceLeft={true}/>)
    }
  }
  if (selFrom) {
    const selQuery = context.getGlobalDef(selFrom)
    if (selQuery) {
      if (selQuery.type === 'query' || (selQuery.source && selQuery.provider)) {
        buttons.unshift(<SelectForm def={selQuery} context={context} spaceLeft={true}/>)
      } else { // global list
        buttons.unshift(<SelectFromGlobal def={selQuery} context={context} spaceRight={true}/>)
      }
    }
  }

  const handleKeyUp = event => {
    if (event.target.nodeName === 'TEXTAREA') {
      event.preventDefault()
      event.stopPropagation()
      return
    }
    if (event.keyCode === 13 || event.keyCode === 27) {
      event.preventDefault()
      handleClose()
    }
  }
  return (
    <Modal
      title={roStr + title + indexStr}
      className={'app-modal'}
      visible={isShow}
      maskClosable={false}
      destroyOnClose={true}
      onOk={handleClose}
      onCancel={handleClose}
      footer={buttons}>
      <div className={'w-100 overflow-auto'} style={{
        minHeight: 400,
        maxHeight: '60vh',
      }}>
        <div className={'p-4'} onKeyUp={handleKeyUp}>
          <DefaultLayout context={context}
                         topRecordId={topRecordId}
                         inLinkedObj={inLinkedObj || Boolean(link)}
                         change={change}
                         isInsideModal={true}
          />
        </div>
      </div>
    </Modal>
  )
}

export default memo(ChildModal)
